// addMessage.js
'use strict';
import { ADD_MESSAGE } from '../ActionTypes.js';

/**
 * Add message
 * @kind action
 * @param {object} {message} - action param.
 * @return {Promise} Action promise.
 */
const addMessage =
  ({ message }) =>
  async dispatch => {
    return dispatch({ type: ADD_MESSAGE, payload: message });
  };

export default addMessage;
